import { render, staticRenderFns } from "./VesselMonitoringSingleBayDeck.vue?vue&type=template&id=fedfbf5e&scoped=true"
import script from "./VesselMonitoringSingleBayDeck.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringSingleBayDeck.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringSingleBayDeck.vue?vue&type=style&index=0&id=fedfbf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedfbf5e",
  null
  
)

export default component.exports